module.exports = __webpack_public_path__ + "img/621-42dfb3.png";